export const initialFileRequestsState = {
    fileRequestsByIdByHomeId: {},
    fileRequestIdsByHomeId: {},
};
